/**
 * Id of the legal text baked into the /privacy and /terms HTML.
 * The app removes that element once JavaScript starts, so people using a
 * browser still see the normal page.
 */
export const PRERENDERED_LEGAL_ID = "prerendered-legal";
